import * as api from '@/api/notifications'
import findIndex from 'lodash/findIndex'

const state = {
  // Subscriptions
  notificationTypes: [],
  notificationSubscriptions: [],

  // Notifications
  notifications: {
    unread: [],
    read: [],
  },
}

const mutations = {
  // Subscriptions
  setTypes: (state, payload) => state.notificationTypes = payload,
  setSubscriptions: (state, payload) => state.notificationSubscriptions = payload,
  pushSubscription: (state, payload) => state.notificationSubscriptions.push(payload),
  removeSubscription: (state, payload) => state.notificationSubscriptions.splice(
    findIndex(state.notificationSubscriptions, { id: payload.id }), 1
  ),

  // Notifications
  setNotifications: (state, payload) => state.notifications = payload,
  pushUnreadNotification: (state, payload) => state.notifications.unread.unshift({
    id: payload.id,
    data: payload
  }),
}

const actions = {
  // Subscriptions
  loadAvailableNotificationTypes: ({ commit }, userId) => new Promise((resolve, reject) => {
    api.loadAvailableNotificationTypes(userId, response => {
      commit('setTypes', response.data)
      resolve()
    }, reject)
  }),

  loadUserSubscriptions: ({ commit }, userId) => new Promise((resolve, reject) => {
    api.loadUserSubscriptions(userId, response => {
      commit('setSubscriptions', response.data)
      resolve()
    }, reject)
  }),

  subscribeUserTo: ({ commit }, { userId, notificationType }) => new Promise((resolve, reject) => {
    api.subscribeUserTo({
      userId,
      notificationTypeId: notificationType.id
    }, () => {
      commit('pushSubscription', notificationType)
      resolve()
    }, reject)
  }),

  unsubscribeUserFrom: ({ commit }, { userId, notificationType }) => new Promise((resolve, reject) => {
    api.unsubscribeUserFrom({
      userId,
      notificationTypeId: notificationType.id
    }, () => {
      commit('removeSubscription', notificationType)
      resolve()
    }, reject)
  }),

  // Notifications
  fetchNotifications: ({ commit }) => new Promise((resolve, reject) => {
    api.fetchNotifications(response => {
      commit('setNotifications', response.data)
      resolve()
    }, reject)
  }),

  readNotification: ({ dispatch }, notification) => new Promise((resolve, reject) => {
    api.readNotification(notification.id, () => {
      dispatch('fetchNotifications'),
      resolve()
    }, reject)
  }),

  readAllNotifications: ({ dispatch }) => new Promise((resolve, reject) => {
    api.readAllNotifications(async () => {
      await dispatch('fetchNotifications'),
      resolve()
    }, reject)
  })
}

const getters = {
  notificationTypes: state => state.notificationTypes,
  notificationSubscriptions: state => state.notificationSubscriptions,
  hasUnreadNotifications: state => state.notifications.unread.length > 0,
  hasSubscription: (state) => (notificationType) => {
    return findIndex(state.notificationSubscriptions, { id: notificationType.id }) >= 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
